import axios from 'axios';
import { API_URL } from '../../../support/api';
import { PaginatedValue } from '../../../support/utils';
import { IFeature } from '../models/Feature';

export const BASE_FEATURE_URL = `${API_URL}/v1/management/module-management/features`;
export const GET_ALL_FEATURE_URL = `${API_URL}/v1/management/module-management/features/get-all`;
export const CREATE_FEATURE_URL = `${API_URL}/v1/management/module-management/features/create`;

export const listFeature = async (search = '', direction = 'asc') => {
  const URL = `${BASE_FEATURE_URL}/list?search=${search}&direction=${direction}`;
  const {
    data: { value },
  } = await axios.get<{ value: PaginatedValue<IFeature> }>(URL);

  return value;
};

export const createFeature = async (payload: IFeature) => {
  const {
    data: { value },
  } = await axios.post<{ value: IFeature }>(CREATE_FEATURE_URL, payload);

  return value;
};

export const viewFeature = async (id: number | string) => {
  const {
    data: { value },
  } = await axios.get<{ value: IFeature }>(`${BASE_FEATURE_URL}/${id}/get`);

  return value;
};

export const updateFeature = async (payload: IFeature) => {
  const {
    data: { value },
  } = await axios.post<{ value: IFeature }>(
    `${BASE_FEATURE_URL}/${payload.id}/update`,
    payload
  );

  return value;
};

export const deleteFeature = async (payload: IFeature) => {
  const {
    data: { value },
  } = await axios.post<{ value: IFeature }>(
    `${BASE_FEATURE_URL}/${payload.id}/delete`,
    payload
  );

  return value;
};

// unpaginated categories
export const getAllFeature = async () => {
  const {
    data: { value },
  } = await axios.get<{ value: Array<IFeature> }>(GET_ALL_FEATURE_URL);

  return value;
};
